import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api.js";
import { toast } from "react-toastify";

/* =========================
   ADD META DATA
========================= */
export const AddMetaDataSlice = createAsyncThunk(
  "admin/addMetaData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.AddMetaDataApi(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);

/* =========================
   GET META DATA (PAGINATED)
========================= */
export const GetMetaDataSlice = createAsyncThunk(
  "admin/getMetaData",
  async ({ type, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const query = `?type=${type}&page=${page}&limit=${limit}`;
      const response = await api.GetMetaDataListApi(query);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);

/* =========================
   DELETE META DATA
========================= */
export const DeleteMetaDataSlice = createAsyncThunk(
  "admin/deleteMetaData",
  async (id, { rejectWithValue }) => {
    try {
      await api.deleteMetaDataApi(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Delete failed" });
    }
  }
);

/* =========================
   UPDATE META DATA
========================= */
export const UpdateMetaDataSlice = createAsyncThunk(
  "admin/updateMetaData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await api.updateMetaDataApi(id, payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Update failed" });
    }
  }
);

/* =========================
   GET META DATA BY ID
========================= */
export const GetMetaDataByIdSlice = createAsyncThunk(
  "admin/getMetaDataById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.getMetaDataByIdApi(id);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Fetch failed" });
    }
  }
);

/* =========================
   SLICE
========================= */
const MetaDataManagementSlice = createSlice({
  name: "MetaDataManagement",
  initialState: {
    list: [],
    selectedMetaData: null, // ✅ REQUIRED FOR EDIT
    pagination: {
      totalRecords: 0,
      currentPage: 1,
      totalPages: 0,
      limit: 10,
    },
    loading: false,
    error: null,
  },

  reducers: {
    // ✅ CLEAR OLD EDIT DATA
    clearSelectedMetaData: (state) => {
      state.selectedMetaData = null;
    },
  },

  extraReducers: (builder) => {
    const pendingState = (state) => {
      state.loading = true;
      state.error = null;
    };

    const rejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Something went wrong";
      toast.error(state.error);
    };

    builder
      /* ADD META DATA */
      .addCase(AddMetaDataSlice.pending, pendingState)
      .addCase(AddMetaDataSlice.fulfilled, (state) => {
        state.loading = false;
        toast.success("Meta Data Saved Successfully");
      })
      .addCase(AddMetaDataSlice.rejected, rejectState)

      /* GET META DATA */
      .addCase(GetMetaDataSlice.pending, pendingState)
      .addCase(GetMetaDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.data || [];
        state.pagination = action.payload?.pagination || state.pagination;
      })
      .addCase(GetMetaDataSlice.rejected, rejectState)

      /* DELETE META DATA */
      .addCase(DeleteMetaDataSlice.pending, pendingState)
      .addCase(DeleteMetaDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter(
          (item) => item._id !== action.payload
        );
        toast.success("Meta Data Deleted Successfully");
      })
      .addCase(DeleteMetaDataSlice.rejected, rejectState)

      /* UPDATE META DATA */
      .addCase(UpdateMetaDataSlice.pending, pendingState)
      .addCase(UpdateMetaDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.list.findIndex(
          (item) => item._id === action.payload._id
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
        toast.success("Meta Data Updated Successfully");
      })
      .addCase(UpdateMetaDataSlice.rejected, rejectState)

      /* GET META DATA BY ID */
      .addCase(GetMetaDataByIdSlice.pending, pendingState)
      .addCase(GetMetaDataByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedMetaData = action.payload; // ✅ PREFILL WORKS
      })
      .addCase(GetMetaDataByIdSlice.rejected, rejectState);
  },
});

/* =========================
   EXPORTS
========================= */
export const { clearSelectedMetaData } =
  MetaDataManagementSlice.actions;

export default MetaDataManagementSlice.reducer;
